import { createAction } from 'typesafe-actions'
import { IncludeCitiesOptions } from './types'

export const funnelOrderThemeCitiesGetRequest = createAction(
  'FUNNEL / THEME_CITIES -> GET_REQUEST',
)()

export const funnelOrderThemeCitiesGetResponse = createAction(
  'FUNNEL / THEME_CITIES -> GET_RESPONSE',
)<IncludeCitiesOptions[]>()

export const funnelOrderThemeCitiesGetFailure = createAction(
  'FUNNEL / THEME_CITIES -> GET_FAILURE',
)<Error>()
